import types from './InventoryHolderType';

/**
 * Подписи видов держателя. Ключ — числовое значение вида.
 */
export default class InventoryHolderTypeTitle {
    static [types.EXTERNAL] = 'Внешний';
    static [types.EXPECTED] = 'Ожидаемый';
}
